module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('flex-grid', {
    staticClass: "GalleryGrid"
  }, _vm._l((_vm.images), function(smugmugId, index) {
    return _c('flex-grid-cell', {
      key: index,
      staticClass: "GalleryGrid-item",
      attrs: {
        "size": _vm.cellSize
      }
    }, [(_vm.ratio) ? _c('div', {
      staticClass: "GalleryGrid-ratioContainer",
      style: (_vm.ratioContainerStyle)
    }, [_c('div', {
      staticClass: "GalleryGrid-ratioContent"
    }, [_c('crop', [_c('image-component', {
      attrs: {
        "smugmug": smugmugId,
        "load": _vm.readyToLoad,
        "fit": "contain",
        "zoom": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openViewer(index)
        }
      }
    })], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.ratio) ? _c('image-component', {
      attrs: {
        "smugmug": smugmugId,
        "load": _vm.readyToLoad,
        "zoom": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openViewer(index)
        }
      }
    }) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445ca0c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryGrid.vue
// module id = 762
// module chunks = 1474